import { Option } from '@sapphire/result';

import { TEMPLATE_MESSAGES } from '@ps/survey-utils';

/**
 * An operator buyer pricing through Target Margin needs a Buyer CPI before
 * launching, so a freshly created template survey without one is flagged right
 * away. Whether the user prices through Target Margin is the caller's call.
 */
export function templateMissingBuyerCpiWarning(
  surveyOfferPrice: number,
): Option<string> {
  return surveyOfferPrice <= 0
    ? Option.some(TEMPLATE_MESSAGES.DOES_NOT_HAVE_BUYER_CPI)
    : Option.none;
}
